module.exports = __webpack_public_path__ + "static/assets/d39b8f0a7db2abc7c7e4fe85b4d5d67a.svg";